export default "__VITE_ASSET__Ba2irjt___"